import { Injectable } from "@angular/core";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

// multi-asset
import { ObjectUtils } from "@bfx/primeng/utils";
import { ATDLUtilities } from "app/order-entry/services/atdl/ATDLUtilities";
import { ATDLNControlType } from "../../data-atdl/enums/atdl-control-type.enum";
import { ATDLNLogicOperator } from "../../data-atdl/enums/atdl-logic-operator.enum";
import { ATDLNOperator } from "../../data-atdl/enums/atdl-operator.enum";
import { ATDLNParameterType } from "../../data-atdl/enums/atdl-parameter-type.enum";

export const ICD_CLOCK_TIME_PATTERN: RegExp = new RegExp(
  "^([0-1]?[0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$",
);

export const ICD_TZ_CLOCK_TIME_PATTERN = new RegExp(
  "^(2[0-3]|[01][0-9]):?([0-5][0-9]):?([0-5][0-9])(Z|[+-](?:2[0-3]|[01][0-9])(?::?(?:[0-5][0-9]))?)?$",
);

/**
 * class interface to standalone static utility methods - these are all static and do not need injection
 */
@Injectable()
export class ATDLUtilityService {
  /**********************************************************************/
  /* CONSTRUCTOR  */

  constructor(private _objectUtils: ObjectUtils) {}

  public getValueFromICDBaseModel(valueModel: any, preferTextValue: boolean = false): any {
    return ATDLUtilities.getValueFromICDBaseModel(valueModel, preferTextValue);
  }

  public fromString(name: string): ATDLNControlType {
    return ATDLUtilities.fromString(name);
  }

  public convertStringToATDLNOperator(oprString: string): ATDLNOperator {
    return ATDLUtilities.convertStringToATDLNOperator(oprString);
  }

  public convertStringToATDLNLogicOperator(oprString: string): ATDLNLogicOperator {
    return ATDLUtilities.convertStringToATDLNLogicOperator(oprString);
  }

  public isSingleParamOperator(oprString: string | ATDLNOperator): boolean {
    return ATDLUtilities.isSingleParamOperator(oprString);
  }

  public convertXSITypeToParameterType(type: string): ATDLNParameterType {
    return ATDLUtilities.convertXSITypeToParameterType(type);
  }

  /**
   * Convert the XML string representation of a control type to local Enum instance. Currently,
   * the type includes the actual NS prefix for the layout namespace - rather than check, we just
   * truncate anything found before a colon
   * @param name
   * @return
   *
   */
  public convertStringToControlType(name: string): ATDLNControlType {
    return ATDLUtilities.convertStringToControlType(name);
  }

  public equals(object1: any, object2: any): boolean {
    return ObjectUtils.equals(object1, object2);
  }

  public clone<T = any>(obj: T): T {
    return ATDLUtilities.clone(obj);
  }

  public compareTimeGreaterOrEqualThan(timeA: string, timeB: string): boolean {
    return ATDLUtilities.compareTimeGreaterOrEqualThan(timeA, timeB);
  }
}
